import React, { useContext, useState } from 'react';
import {
  Box,
  Container,
  Card,
  CardHeader,
  Divider,
  CardContent,
  Tabs,
  Tab,
} from '@mui/material';
import { FormStep, Pick } from 'src/models';
import { CycleContext } from 'src/context/CycleContext';
import { NewPicksPanel } from './NewPicksPanel';
import PicksTable from 'src/components/Picks/PicksTable';
import RoundClosedCard from 'src/components/Picks/RoundClosedCard';

type TabPanelProps = {
  children?: React.ReactNode;
  index: number;
  value: number;
};

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 0 }}>{children}</Box>}
    </div>
  );
};

const a11yProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
};

type Props = {
  firstRoundPicks: Pick[];
  secondRoundPicks: Pick[];
  thirdRoundPicks: Pick[];
  fourthRoundPicks: Pick[];
  firstRoundSteps: FormStep[];
  secondRoundSteps: FormStep[];
  thirdRoundSteps: FormStep[];
  fourthRoundSteps: FormStep[];
};

const NewPicksCard = ({
  firstRoundPicks,
  secondRoundPicks,
  thirdRoundPicks,
  fourthRoundPicks,
  firstRoundSteps,
  secondRoundSteps,
  thirdRoundSteps,
  fourthRoundSteps,
}: Props) => {
  const cycle = useContext(CycleContext);
  const [tab, setTab] = useState(cycle.activeRound - 1);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  const RoundClosed = (picks: Pick[]) => {
    return picks.length === 0 ? (
      <RoundClosedCard />
    ) : (
      <PicksTable picks={picks} />
    );
  };

  return (
    <Container maxWidth='sm' disableGutters sx={{ mt: 3 }}>
      <Card>
        <CardHeader
          title={`MY PICKS ${cycle.season.toString().slice(4, 8)}`}
          titleTypographyProps={{ flex: '1 1 100%', variant: 'h6' }}
        />
        <Divider />
        <CardContent>
          <Tabs
            variant='fullWidth'
            value={tab}
            onChange={handleTabChange}
            aria-label='mypicks-round-tabs'
          >
            <Tab label='RD 1' {...a11yProps(0)} />
            <Tab label='RD 2' {...a11yProps(1)} />
            <Tab label='RD 3' {...a11yProps(2)} />
            <Tab label='RD 4' {...a11yProps(3)} />
          </Tabs>
          <TabPanel value={tab} index={0}>
            {!!!cycle.roundOneStatus ? (
              RoundClosed(firstRoundPicks)
            ) : (
              <NewPicksPanel picks={firstRoundPicks} steps={firstRoundSteps} />
            )}
          </TabPanel>
          <TabPanel value={tab} index={1}>
            {!!!cycle.roundTwoStatus ? (
              RoundClosed(secondRoundPicks)
            ) : (
              <NewPicksPanel
                picks={secondRoundPicks}
                steps={secondRoundSteps}
              />
            )}
          </TabPanel>
          <TabPanel value={tab} index={2}>
            {!!!cycle.roundThreeStatus ? (
              RoundClosed(thirdRoundPicks)
            ) : (
              <NewPicksPanel picks={thirdRoundPicks} steps={thirdRoundSteps} />
            )}
          </TabPanel>
          <TabPanel value={tab} index={3}>
            {!!!cycle.roundFourStatus ? (
              RoundClosed(fourthRoundPicks)
            ) : (
              <NewPicksPanel
                picks={fourthRoundPicks}
                steps={fourthRoundSteps}
              />
            )}
          </TabPanel>
        </CardContent>
      </Card>
    </Container>
  );
};

export default NewPicksCard;
